import axios from 'axios';

const APP_BASE_URL = 'https://back-end.mad-dev.pp.ua/api';

const axiosWeb = axios.create();

axiosWeb.interceptors.request.use(
  async (config: any) => {
    config.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    config.baseURL = APP_BASE_URL;
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);
export default axiosWeb;
